/**
 * Formats global text by applying index-based capitalization.
 *
 * @param {string} text - Input text
 * @param {number[]} capitalizeIndexes - Word indexes (0-based) to capitalize
 * @returns {string}
 */
export function globalTextFormat(text = "", capitalizeIndexes = []) {
  if (typeof text !== "string") return "";

  const indexes = new Set(capitalizeIndexes);

  return text
    .trim()
    .split(/\s+/)
    .map((word, index) =>
      indexes.has(index)
        ? word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
        : word.toLowerCase(),
    )
    .join(" ");
}
